import { View } from "../Base";
import { formatLongTime } from "../../utils/routes";
import { makeStyles } from "@mui/styles";
import { memo } from "react";

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginLeft: "2px",
    height: "100%",
    display: "flex",
    alignItems: "center",
    "& svg": {
      width: "12px",
      height: "12px",
    },
  },
});

export const TimeInfo = memo(({ time, icon }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      {Array.isArray(time) ? (
        <>{`${formatLongTime(time[0])} - ${formatLongTime(time[1])}`}</>
      ) : (
        <>
          {formatLongTime(time)} <View className={styles.icon}>{icon}</View>
        </>
      )}
    </View>
  );
});
